export const DOCUMENT_TYPE_INSURANCE_FRONTPAGE = 'insurance-frontpage';
